/*------------------------------------------------
// File Name:PDM_DR_UserInfo.js
// File Description:PDM_DR_UserInfo API方法js接口
// Author:zxl
// Create Time:2023/07/18 17:33:39
//------------------------------------------------*/
import { axios } from '@/utils/request'

const api = {
   _drUserinfo: "/PDM_DR_UserInfo"
}

export default api


//-------------------创建对象-------------------
export function CreatePDM_DR_UserInfoEntity(parameter) {
    return axios({
        url: api._drUserinfo + "/CreatePDM_DR_UserInfoEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------获取列表-------------------
export function GetPDM_DR_UserInfoList(parameter) {
    return axios({
        url: api._drUserinfo + "/GetPDM_DR_UserInfoList",
        method: 'post',
        data: parameter
    })
}

//-------------------分页获取列表---------------
export function GetPDM_DR_UserInfoListByPage(parameter) {
    return axios({
        url: api._drUserinfo + "/GetPDM_DR_UserInfoListByPage",
        method: 'post',
        data: parameter
    })
}

//-------------------获取对象---------------
export function GetPDM_DR_UserInfoEntity(parameter) {
    return axios({
        url: api._drUserinfo + "/GetPDM_DR_UserInfoEntity",
        method: 'post',
        data: parameter
    })
}


//-------------------保存对象---------------
export function UpdatePDM_DR_UserInfoEntity(parameter) {
    return axios({
        url: api._drUserinfo+ "/UpdatePDM_DR_UserInfoEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------删掉对象---------------
export function DeletePDM_DR_UserInfoEntity(parameter) {
    return axios({
        url: api._drUserinfo + "/DeletePDM_DR_UserInfoEntity",
        method: 'post',
        data: parameter
    })
}
